import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IProductionEstimationApiClient {
    getProductionEstimates: (igsCustomerNumber: string) => ng.IPromise<Models.CostCalculation.ProductionEstimateResult.IProductionEstimateResult>;
    calculateProductionEstimates: (igsCustomerNumber: string) => ng.IPromise<Models.CostCalculation.ProductionEstimateResult.IProductionEstimateResult>;
}

export class ProductionEstimationApiClient implements IProductionEstimationApiClient {
    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    }

    public getProductionEstimates = (igsCustomerNumber: string): ng.IPromise<Models.CostCalculation.ProductionEstimateResult.IProductionEstimateResult> => {
        return this.igsApiClientService.get(`Customer/${igsCustomerNumber}/ProductionEstimate`);
    }

    public calculateProductionEstimates = (igsCustomerNumber: string): ng.IPromise<Models.CostCalculation.ProductionEstimateResult.IProductionEstimateResult> => {
        var request = new Models.CostCalculation.ProductionEstimateRequest.ProductionEstimateRequest(igsCustomerNumber);
        return this.igsApiClientService.post("ProductionEstimate/CalculateProductionEstimate", request);
    }
}
